import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhone, faEnvelope, faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons';

const FooterContainer = styled.footer`
  background-color: var(--primary-color);
  color: var(--text-light);
  padding: var(--spacing-lg) 0;
`;

const FooterContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 var(--spacing-sm);
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: var(--spacing-md);
`;

const FooterColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-sm);
`;

const FooterLogo = styled.div`
  font-family: 'Playfair Display', serif;
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--accent);
  margin-bottom: var(--spacing-sm);
`;

const FooterHeading = styled.h4`
  font-size: 1.25rem;
  margin-bottom: var(--spacing-sm);
  color: var(--accent);
`;

const FooterText = styled.p`
  margin-bottom: var(--spacing-xs);
  font-size: 0.9rem;
  line-height: 1.6;
`;

const ContactItem = styled.div`
  display: flex;
  align-items: center;
  gap: var(--spacing-xs);
  margin-bottom: var(--spacing-xs);
  
  svg {
    color: var(--accent);
  }
`;

const ContactLink = styled.a`
  color: var(--text-light);
  transition: var(--transition-fast);
  
  &:hover {
    color: var(--accent);
  }
`;

const Copyright = styled.div`
  text-align: center;
  padding-top: var(--spacing-md);
  margin-top: var(--spacing-md);
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  font-size: 0.875rem;
  opacity: 0.7;
  max-width: 1200px;
  margin: var(--spacing-md) auto 0;
  position: relative;
`;

const AdminLink = styled(Link)`
  position: absolute;
  right: 0;
  bottom: 0;
  font-size: 0.75rem;
  color: rgba(255, 255, 255, 0.3);
  text-decoration: none;
  transition: all var(--transition-medium);
  padding: 0.25rem 0.5rem;
  
  &:hover {
    color: var(--accent);
    opacity: 1;
  }
  
  @media (max-width: 768px) {
    position: static;
    display: block;
    margin-top: 0.5rem;
    text-align: center;
  }
`;

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <FooterContainer>
      <FooterContent>
        <FooterColumn>
          <FooterLogo>Touré VTC</FooterLogo>
          <FooterText>
            Service de chauffeur privé professionnel. Nous offrons des prestations 
            sur mesure pour tous vos déplacements avec élégance, confort et ponctualité.
          </FooterText>
        </FooterColumn>
        
        <FooterColumn>
          <FooterHeading>Contact</FooterHeading>
          <ContactItem>
            <FontAwesomeIcon icon={faPhone} />
            <ContactLink href="tel:+33695808096">+33 6 95 80 80 96</ContactLink>
          </ContactItem>
          <ContactItem>
            <FontAwesomeIcon icon={faEnvelope} />
            <ContactLink href="mailto:contact@vtcprivetoure.fr">
              contact@vtcprivetoure.fr
            </ContactLink>
          </ContactItem>
          <ContactItem>
            <FontAwesomeIcon icon={faMapMarkerAlt} />
            <FooterText>France, Belgique, Luxembourg, Suisse, Espagne</FooterText>
          </ContactItem>
        </FooterColumn>
        
        <FooterColumn>
          <FooterHeading>Horaires</FooterHeading>
          <FooterText>
            Service disponible 24/7 pour les réservations anticipées
          </FooterText>
        </FooterColumn>
      </FooterContent>
      
      <Copyright>
        © {currentYear} Touré VTC. Tous droits réservés.
        <AdminLink to="/login">Administration</AdminLink>
      </Copyright>
    </FooterContainer>
  );
};

export default Footer; 